import React from "react";
import { SaveButton, Toolbar } from "react-admin";

const CustomCreateToolbar = (props: any) => (
  <Toolbar {...props}>
    <SaveButton
      redirect={props.directAction ?? "show"}
      disabled={props.invalid}
    />
  </Toolbar>
);

export default CustomCreateToolbar;
